import React, {Component} from "react";
import PropTypes from "prop-types";
import "bootstrap";
import {connect} from "react-redux";
import i18next from "i18next";
import {withRouter} from 'react-router';
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam.js";
import PopupWrapper from "../Common/PopupWrapper";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";
import {renderHTML} from "@mnjsplatform/data/lib/utils/htmlUtils";
import {formatMnDate} from "@mnjsplatform/data/lib/utils/formatData";
import paramRender from "@mnjsplatform/components/lib/common/ParamRenderUniversal";

class EditDelegate extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isDataReady: false
        };
    }

    componentDidMount() {
        console.log("EditDelegate mount");
        this.initialize();
    }

    componentWillUnmount() {
        console.log("EditDelegate unmount");
    }

    initialize = async () => {
        try {
            await this.props.dispatch(this.props.dataItem.reset());
            await this.props.dispatch(this.props.dataItem.initialize(this.props.rowKey, {
                refresh: true,
                withParams: false,
                newItem: true
            }));

            if (this.props.addMode) {
                await this.props.dispatch(this.props.dataItem.beginAdd());
            } else {
                await this.props.dispatch(this.props.dataItem.beginEdit(0));
            }

            if (!this.props.dataItem.isError) {
                this.setState({isDataReady: true});
            }
        } catch (e) {
            await this.props.dispatch(e);
        }
    }

    onSave = async (employee) => {
        const dateBeg = this.props.dataItem.getField(0, 'DateBeg');
        const dateEnd = this.props.dataItem.getField(0, 'DateEnd');
        await confirm(renderHTML(i18next.t("Edit_Delegate_1",
            {employee: employee, dateBegin: formatMnDate(dateBeg), dateEnd: formatMnDate(dateEnd)})),
            {header: i18next.t("Edit_Delegate_2")});
        await this.props.dispatch(this.props.dataItem.save());
        if (this.props.dataItem.isError) {
            this.setState({
                messageText: this.props.dataItem.isError ? i18next.t("Error") : i18next.t("SuccessfulExecution"),
                messageTitle: this.props.dataItem.isError ? i18next.t("Error") : i18next.t("SuccessfulExecution"),
                showMessage: !this.props.dataItem.isError
            });
        } else {
            if (this.props.addMode && this.props.onCreated) {
                const rowKey = this.props.dataItem.getRowKeyByIndex(0);
                this.props.onCreated(rowKey);
            }
            this.onClose();
        }
    }

    onClose = () => {
        if (this.props.onClose)
            this.props.onClose();
    }

    render() {
        if (!this.state.isDataReady)
            return null;

        const renderButtons = () => {
            let employee = this.props.dataItem.getField(0, "ToName");
            employee = employee ? employee.trim() : null;
            employee = employee == '' ? null : employee;

            return (<div className="modal-footer text-right">
                <button type="button" disabled={!this.state.isDataReady || !employee}
                        className="btn btn-regular -goahead  ml1ex" data-dismiss="modal"
                        onClick={() => this.onSave(employee)}>{i18next.t("Save")}</button>
                <button type="button" className="btn btn-regular ml1ex" data-dismiss="modal"
                        onClick={this.onClose}>{i18next.t("Close")}</button>
            </div>)
        }
        return (
            <PopupWrapper popupVisible={true} title={i18next.t("Request_1")} renderButtons={renderButtons}
                          onClose={this.props.onClose}>
                <div>
                    {!this.state.isDataReady ?
                        i18next.t('LoadingLabel')
                        : <React.Fragment>
                            <PlaceholderWrapper placeholderId="10" showHeaderTitle={false} canCollapse={false}
                                                showSplitterLine={false}>
                                <ComplexParam dataItem={this.props.dataItem}
                                              showSearchBar={false} showApplyButton={false} autoApplyParams={false}
                                              readOnly={false} renderParams={paramRender}
                                />
                            </PlaceholderWrapper>
                        </React.Fragment>
                    }
                </div>
            </PopupWrapper>
        )
    }
}

EditDelegate.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem: PropTypes.object,
    dataItem_Params: PropTypes.object,
    addMode: PropTypes.bool
};

EditDelegate.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        dataItem: state.rvdState.WorkHolReqProxy_POBx_List_One
    }
}

export default withRouter(connect(mapStateToProps)(EditDelegate));